'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Rocket01Icon, SearchRemoveIcon } from '@/components/ui/icon/glyphs';
interface ProposalEmptyStateProps {
  variant: 'no-proposals' | 'no-results';
  onCreateClick?: () => void;
  onClearFilters?: () => void;
}
export function ProposalEmptyState(t0) {
  const $ = _c(22);
  const {
    variant,
    onCreateClick,
    onClearFilters
  } = t0;
  const t = useTranslations("launchpad.feed");
  if (variant === "no-results") {
    let t1;
    if ($[0] !== t) {
      t1 = t("emptyFilterTitle");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t) {
      t2 = t("emptyFilterSubtitle");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== onClearFilters || $[5] !== t) {
      t3 = onClearFilters !== undefined ? <AnimatedButton variant="secondary" onClick={onClearFilters}>{t("clearFilters")}</AnimatedButton> : undefined;
      $[4] = onClearFilters;
      $[5] = t;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
      t4 = <EmptyState size="page" icon={SearchRemoveIcon} title={t1} description={t2} action={t3} />;
      $[7] = t1;
      $[8] = t2;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t1;
  if ($[11] !== t) {
    t1 = t("emptyTitle");
    $[11] = t;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== t) {
    t2 = t("emptySubtitle");
    $[13] = t;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== onCreateClick || $[16] !== t) {
    t3 = onCreateClick !== undefined ? <AnimatedButton onClick={onCreateClick}>{t("launchCta")}</AnimatedButton> : undefined;
    $[15] = onCreateClick;
    $[16] = t;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3) {
    t4 = <EmptyState size="page" icon={Rocket01Icon} title={t1} description={t2} action={t3} />;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}